import { graphql } from "../../../generated"

export const PHONE_NUMBER_FRAGMENT = graphql(`
    fragment PhoneNumber on PhoneNumber {
        e164
        ... on NorthAmericanPhoneNumber {
            ...NorthAmericanPhoneNumberFields
        }
    }
`)

export const IDENTITY_NORTH_AMERICAN_PHONE_NUMBER_FRAGMENT = graphql(`
    fragment NorthAmericanPhoneNumberFields on NorthAmericanPhoneNumber {
        concise: formatted(format: CONCISE)
        formatted
        areaCode
        centralOfficeCode
        lineNumber
    }
`)
